import type { DeviceModel } from '../../types/deviceModel';
import { portRow, simpleLayout } from './layoutHelpers';

export const patchPanel24Model: DeviceModel = {
  equipmentId: 'patch-panel-24',
  selfDrawWatts: 0,
  isPassthroughDevice: true,
  powerInputs: [],
  layout: {
    simple: simpleLayout(
      [
        ...portRow({
          count: 12,
          startNumber: 1,
          kind: 'rj45',
          speedsMbps: [10, 100, 1000, 10000],
          passthrough: true,
          y: 12,
        }),
        ...portRow({
          count: 12,
          startNumber: 13,
          kind: 'rj45',
          speedsMbps: [10, 100, 1000, 10000],
          passthrough: true,
          y: 40,
          flipped: true,
        }),
      ],
      360,
      80
    ),
  },
};
